module.exports = __webpack_public_path__ + "static/media/Ram894_4c.c435e490.svg";